import { createSlice } from "@reduxjs/toolkit";

const initialArticlesState = {
  articlesList: [],
  listLoading: false,
  error: null,
  categoriesList: [],
  poll: null,
  pollLoading: false,
  article: null,
  articleCreating: false,
  articleGet: null,
  articleLoading: false,
  articleUpdating: false,
  articleUpdated: null,
  hideLoading: false,
  articleHided: null,
  articleDeleted: null,
  deleteLoading: false,
  articleCreated: false,
};

export const callTypes = {
  list: "list",
  get: "get",
  createPoll: "createPoll",
  createArticle: "createArticle",
  updateArticle: "updateArticle",
  hide: "hide",
  delete: "delete",
};

export const articlesSlice = createSlice({
  name: "Article",
  initialState: initialArticlesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.error?.response?.data.message}`;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = false;
          break;
        case callTypes.createArticle:
          state.articleCreating = false;
          break;
        case callTypes.get:
          state.articleLoading = false;
          break;
        case callTypes.updateArticle:
          state.articleUpdating = false;
          break;
        case callTypes.hide:
          state.hideLoading = false;
          break;
        case callTypes.delete:
          state.deleteLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = true;
          break;
        case callTypes.createArticle:
          state.articleCreating = true;
          break;
        case callTypes.get:
          state.articleLoading = true;
          break;
        case callTypes.updateArticle:
          state.articleUpdating = true;
          break;
        case callTypes.hide:
          state.hideLoading = true;
          break;
        case callTypes.delete:
          state.deleteLoading = true;
          break;
        default:
          break;
      }
    },
    articlesFetched: (state, action) => {
      state.articlesList = action.payload.articlesList;
      state.listLoading = false;
      state.error = null;
    },
    articleFetched: (state, action) => {
      state.articleGet = action.payload.articleGet;
      state.articleLoading = false;
      state.error = null;
    },
    categoriesFetched: (state, action) => {
      state.categoriesList = action.payload.categoriesList;
      state.listLoading = false;
      state.error = null;
    },
    articlePollCreated: (state, action) => {
      state.poll = action.payload.poll;
      state.pollLoading = false;
      state.error = null;
    },

    articleRemovePoll:(state, action) => {     
      state.poll = undefined;    
      state.pollLoading = false;
      state.error = null;
    },

    articleCreated: (state, action) => {
      state.articleCreated = action.payload.articleCreated;
      state.articleCreating = false;
      state.error = null;
    },
    articleUpdated: (state, action) => {
      state.articleUpdated = action.payload.articleUpdated;
      state.articleUpdating = false;
      state.error = null;
    },
    articleCleanState: (state, action) => {
      state.articlesList = [];
      state.error = null;
      state.categoriesList = [];
      state.poll = null;
      state.article = null;
      state.articleGet = null;
      state.articleHided = null;
    },
    articleListCleanState: (state, action) => {
      state.error = null;
      state.poll = null;
      state.article = null;
      state.articleGet = null;
      state.articleHided = null;
    },
    articleEditCleanState: (state, action) => {
      state.articleGet = null;
      state.articleUpdated = null;
      state.poll = null;
      state.articleHided = null;
    },
    articleCreatedCleanState: (state, action) => {
      state.articleCreated = null;
      state.articleHided = null;
    },
    articleHided: (state, action) => {
      state.articleHided = action.payload.articleHided;
      state.hideLoading = false;
      state.error = null;
    },
    articleDeleted: (state, action) => {
      state.articleDeleted = action.payload.articleDeleted;
      state.deleteLoading = false;
      state.error = null;
    },
  },
});
